import { render } from "./DeletedManageAccounts.vue?vue&type=template&id=2f119312"
import script from "./DeletedManageAccounts.vue?vue&type=script&lang=js"
export * from "./DeletedManageAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__